import CreditBalanceContent from './credit-balance-content'

export default CreditBalanceContent
